export const HeaderDetails = ({tituloprincipal = "", area = "", nivel = "", prioridad = "", titulo = "", usuarioresponsable= ""}) => {
  return (
    <>
      <div className='row'>
        <div className="col-12">
          <h2 className="font-weight-bold">{tituloprincipal}</h2>  
          <hr />
        </div>
      </div>
      <div className='row'>
        <div className="col-12">
          <div className="d-flex flex-row justify-content-between">
              <p><span className="font-weight-bold">AREA</span> &nbsp;{area}</p><p><span className="font-weight-bold">NIVELES</span> {nivel}</p> <p><span className="font-weight-bold">PRIORIDAD</span> &nbsp;{prioridad}</p><p><span className="font-weight-bold">USUARIO RESPONSABLE</span> &nbsp;{usuarioresponsable}</p>
            </div>
        </div>
      </div>
      <div className='row'>
        <div className="col-12 col-md-4">
          <span className="font-weight-bold">TITULO</span> &nbsp;{titulo}
        </div>
      </div>
    </>
  )
}
